import { render, staticRenderFns } from "./_layout.front.vue?vue&type=template&id=25a71c20"
import script from "./_layout.front.vue?vue&type=script&lang=js"
export * from "./_layout.front.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports